import React from 'react'
import { Switch } from 'react-router-dom'

import { PermissionRoute } from '../../common/components/routes'
import { APP_ROUTES, PERMISSIONS } from '../../common/constants'

import { CourseTypeDetailsPage, CourseTypesPage } from './pages'

const CourseTypesRouter = () => (
  <Switch>
    <PermissionRoute
      exact
      path={APP_ROUTES.COURSE_TYPES.link}
      permissions={[PERMISSIONS.METADATA_TREE.LIST]}
      component={CourseTypesPage}
    />
    <PermissionRoute
      exact
      path={APP_ROUTES.COURSE_TYPE_DETAILS.link}
      permissions={[PERMISSIONS.METADATA_TREE.GET]}
      component={CourseTypeDetailsPage}
    />
  </Switch>
)

export default CourseTypesRouter
